import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from "recharts";

interface ExamReadinessGaugeProps {
  score: number;
}

export function ExamReadinessGauge({ score }: ExamReadinessGaugeProps) {
  const data = [{ name: 'Readiness', value: score, fill: getColor(score) }];

  function getColor(value: number) {
    if (value < 60) return "hsl(var(--destructive))";
    if (value < 80) return "hsl(var(--chart-3))";
    return "hsl(var(--chart-4))";
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Exam Readiness Score</CardTitle>
        <CardDescription>Based on your performance trends</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center">
        <ResponsiveContainer width="100%" height={200}>
          <RadialBarChart 
            cx="50%" 
            cy="50%" 
            innerRadius="70%" 
            outerRadius="90%" 
            data={data}
            startAngle={180}
            endAngle={0}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
            <RadialBar 
              background 
              dataKey="value" 
              cornerRadius={10}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="text-center mt-4">
          <div className="text-4xl font-bold">{score}%</div>
          <p className="text-sm text-muted-foreground mt-2">
            {score < 60 && "Keep practicing to improve your readiness"}
            {score >= 60 && score < 80 && "You're on the right track!"}
            {score >= 80 && "Excellent! You're well-prepared"}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
